import { Component, ElementRef, ViewChild, inject } from '@angular/core';
import { DatePipe, Location } from '@angular/common';
import {SettingsService} from 'src/app/services/settings.service'
import { Router ,ActivatedRoute} from '@angular/router';
import { PageEvent } from '@angular/material/paginator';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators,FormControl } from '@angular/forms'
import { ToastMsg, ToastmsgService } from 'src/app/util/toastmsg/toastmsg.service';
import { Observable, Subscription, map, startWith } from 'rxjs';
import {AirManagementService}  from 'src/app/services/air-management.service'
import {PaymentConfigService}  from 'src/app/services/payment-config.service'
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import {LiveAnnouncer} from '@angular/cdk/a11y';
import { MatChipInputEvent } from '@angular/material/chips';
import {StaticdataService}  from 'src/app/services/staticdata.service'
@Component({
  selector: 'app-miles',
  templateUrl: './miles.component.html',
  styleUrls: ['./miles.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({height: '0px', minHeight: '0'})),
      state('expanded', style({height: '*'})),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class MilesComponent {
  fileSelected:boolean=false
  selectedFile:any=null
    action:any
  mileRegFg!:FormGroup
  showMilePopup:boolean=false
  mealData:any=[]
  columnsMilesDisplay: string[] = ['formAirport','toAirport','value','carrierName'];
  expandedElement!: any | null;
  totalElements:any=0
  pageStr:any={
    number:'0',
    size:'10'
  }
  searchText:any=""

constructor(private fb : FormBuilder,private AirManagementService:AirManagementService,private toastMsgService : ToastmsgService){
this.sourceCodelist()
this.carrierCodelist()
  this.dataFields()
  this.MilesList()

}
  formatDate(val: Date) {
    let convertedValue:any = ""
    if(val){
    let datepipe = new DatePipe("en");
    //return datepipe.transform(val, "dd-MM-yyyy hh:mm:ss");
    convertedValue =  datepipe.transform(val, "dd-MM-yyyy hh:mm:ssa");
    }
    return convertedValue;
  }

  rowMileClick(element:any){
    this.action="update"
    this.showMilePopup=true

    this.mileRegFg=this.fb.group({
      "fromAirport":[element?.fromAirport,[Validators.required]],
      "toAirport":[element?.toAirport,[Validators.required]],
      "value":[element?.value,[Validators.required]],
      "carrierName":[element?.carrierName,[Validators.required]],
      "unit":[element?.unit,[Validators.required]]
      
    });
  }


  closePopup(){
this.showMilePopup=false
this.dataFields()
  }
  dataFields(){
  
    this.mileRegFg=this.fb.group({
      "fromAirport":['',[Validators.required]],
      "toAirport":['',[Validators.required]],
      "value":['',[Validators.required]],
      "carrierName":['',[Validators.required]],
      "unit":['',[Validators.required]]
      
    });
  }
  AddMile() {
    this.AirManagementService.saveMiles(this.mileRegFg.value)
      .subscribe({
        next : (res) => {
          if(res.status==200 || res.status==201) {
            this.toastMsgService.setMsg({msg : "Mile Added Successfully!",msgTitle : "Success", msgType : "I"});
           // this.router.navigate(["/sign-in"]);
           this.dataFields();
           this.showMilePopup=false

          } else {
            const body : any = res.body;
            this.registerMileErrorMsg(res.status,body?.result);
          } 

        },error : (err) => {

          this.registerMileErrorMsg(err.status,err.error);
        }
      }
    )
  }

  registerMileErrorMsg(status : number,msg : string) {
    if(status >=500) {
      this.toastMsgService.setMsg({msg : "Failed to save Mile",msgTitle : "Warning", msgType : "W"});
    } else {

      this.toastMsgService.setMsg({msg : "Failed to save Mile",msgTitle:  "Warning", msgType : "W"});
    } 
  }
  
  

  carrierCodeList:any=[]
  sourceCodeList:any=[]
sourceCodelist(){

  this.AirManagementService
  .sourceCodelist()
  .subscribe({
    next : (res:any) => {
      if(res) {
     let data=res
     this.sourceCodeList=data
     
      } else {
      
      } 
    },error : (err) => {

    }
  }
)
}
carrierCodelist(){

  this.AirManagementService
  .carrierlist()
  .subscribe({
    next : (res:any) => {
      if(res) {
     let data=res
     this.carrierCodeList=data
     
      } else {
      
      } 
    },error : (err) => {

    }
  }
)
}

onAddMile(){
  this.action="new"

  this.showMilePopup=true
  this.dataFields()
}
onlyNumberKey(event:any) {
     
  let charCode = (event.which) ? event.which : event.keyCode;
  if (charCode != 46 && charCode > 31
      && (charCode < 48 || charCode > 57))
      return false;
  return true;
}

sourceName(item:any){
  if(item){
   let code:any=[]
   console.log(this.sourceCodeList)
   console.log(item)
   code =this.sourceCodeList.filter((items:any)=>items.code===item.toString())
   console.log(code)
   if(code.length>0){
    return code[0].title}
    else{
return item
    }
  }else{
    return item
  }

}

onFileSelected(event: any): void {
    
  this.fileSelected=true;


this.selectedFile = event.target.files[0] ?? null;

}

uploadFile(){
this.fileSelected=true;

this.AirManagementService
.UploadMiles(this.selectedFile)
.subscribe({
  next : (res:any) => {
    if(res) {

    this.fileSelected=false
    this.selectedFile=null
    this.showMilePopup=false

      this.toastMsgService.setMsg({msg : "Upload File Successfully!",msgTitle : "Success", msgType : "I"});

    } else {
    
    } 
  },error : (err) => {
    this.toastMsgService.setMsg({msg : "Failed to Upload File",msgTitle : "Warning", msgType : "W"});


  }
}
)
}

searchFilter(){
  this.MilesList()
}

nextPage(event:PageEvent) {
    
  let page:any = {};
  this.pageStr['number'] = event.pageIndex.toString();
  this.pageStr['size'] = event.pageSize.toString();
  this.MilesList()
  //this.getAllUser(page)

}
MilesList(){

  this.AirManagementService
  .getMilesList(this.pageStr,this.searchText)
  .subscribe({
    next : (res:any) => {
      if(res) {
     let data=res

     if(data.result.content.length>0){
      this.pageStr.number=data.result['number']
      this.pageStr.size=data.result['size']
    }
    this.totalElements = data.result['totalElements'];
    this.mealData=data.result['content']
      } else {
      
      } 
    },error : (err) => {

    }
  }
)
}

}
